<script type="text/javascript">
export default {
  data() {
    return {};
  },
  
  computed: {
    topicId() {
      return this.$parent.$props.topicId;
    },
    userId() {
      return this.$parent.$props.userId;
    },
    gameId() {
      return this.$parent.$props.gameId;
    },
    replyId() {
      return this.$parent.$props.replyId;
    },
    row() {
      return this.$parent.$props.row || {};
    },
    isSelf() {
      return this.$store.getters.isSelf(this.userId);
    },
    isPc() {
      return this.$store.getters.ua.isPc;
    },
    isiOS() {
      var u = navigator.userAgent;
      if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        return true
      } else {
        return false
      }
    },
    isLogin() {
      return this.$store.getters.isLogin
    }
  },
  methods: {
    addHttp(url) {
      if (url.charAt(0, 4) != 'http') {
        return 'https://' + url
      } else {
        return url
      }
    },
    gotourl2(url, android_name, ios_whitelist_name, app_store_id) {
      if (this.isPc) {
        // this.opendownloadurl(url)
      } else {
        if (this.isiOS) {
          if (ios_whitelist_name != '') {
            window.location.href = url
          }
          var appIosParams = {
            ios_whitelist_name,
            app_store_id
          }
          window.webkit.messageHandlers.launchGame.postMessage(JSON.stringify(appIosParams));
        } else {
          window.open(url)
          var appAnParams = {
            android_name,
            game_bag_url: url
          }
          window.android.launchGame(JSON.stringify(appAnParams));
        }
      }
    },
    gotourl(url) {
      window.location.href = this.addHttp(url)
    },
    iosdown(url, ios_whitelist_name, app_store_id) {
      if (url != '') {
        window.location.href = url
        var appIosParams = {
          ios_whitelist_name,
          app_store_id
        }
        window.webkit.messageHandlers.launchGame.postMessage(JSON.stringify(appIosParams));
      }
    },
    andown(url, android_name) {
      if (url != '') {
        window.open(url)
        var appAnParams = {
          android_name,
          game_bag_url: url
        }
        window.android.launchGame(JSON.stringify(appAnParams));
      }
    },
    //跳转游戏详情
    gotoGameDetail(gameId) {
      if (!["string", "number"].includes(typeof gameId)) {
        gameId = this.gameId;
      }
      this.$router.push({
        name: 'forum.game.detail',
        params: {
          gameId
        }
      })
    },
    // 跳转到个人中心
    goToUserCenter(userId) {
      if (this.isLogin) {
        if (!["string", "number"].includes(typeof userId)) {
          userId = this.userId;
        }
        if (userId > 0) {
          this.$router.push({
            name: 'user.center',
            query: {
              userId
            }
          })
        }
      } else {
        this.$mypopup({
          onSuccess: () => {
            if (!["string", "number"].includes(typeof userId)) {
              userId = this.userId;
            }
            if (userId > 0) {
              this.$router.push({
                name: 'user.center',
                query: {
                  userId
                }
              })
            }
          }
        })
      }
    },
    // 跳转到游戏版块
    goToGame(gameId) {
      if (!["string", "number"].includes(typeof gameId)) {
        gameId = this.gameId;
      }
      if (gameId > 0) {
        // const url = "/forum/game/" + gameId;
        // window.location.href = url;
        // if (this.isPc) {
        //   window.open(url);
        // } else {

        // }
        this.$router.push({
          name: 'game',
          params: {
            gameId
           }
        })
      }
    },
    goToGameName(gameId) {
      this.$router.push({
        name: 'game',
        params: {
          gameId
         }
      })
      // const url = "/forum/game/" + gameId;
      // window.location.href = url;
    },
    // 跳转到帖子
    goToTopic() {
      // 有评论不跳转
      // if (this.replyId > 0) return;
      // if (!["string", "number"].includes(typeof topicId)) {
      //   topicId = this.topicId;
      // }
      // if (topicId > 0) {
      //   const url = "/forum/topic/" + topicId;
      //   if (this.isPc) {
      //     window.open(url);
      //   } else {
      //     //window.location.href = url;
      //     this.$router.push({
      //       name: "topic",
      //       params: {
      //         topicId
      //       }
      //     });

      //   }

      // }
      if(this.isTop) {
        this.getGameHit(3)
      }
      this.$router.push({name: 'topic',params: {topicId: this.topicId}})
    },
    //点击量
    getGameHit(type) {
      this.$Ajax('create-game-hits',{gameId: this.gameId,type})
    },
    //前往
    gotoGambit(id) {
      this.$router.push({
        name: 'gambit',
        query: {
          discussId: id
        }
      })
    },
    // 编辑帖子
    doEdit() {
      this.$Ajax("rough-detail", {
        topicId: this.topicId
      }).then(rs => {
        const data = rs.data;
        this.$RModal.topic({
          title: "编辑帖子",
          name: data.title,
          selection: {
            topicId: this.topicId,
            gameId: this.gameId,
            tagId: data.tag_id,
            title: data.title,
            content: data.content,
            attachments: data.attachments,
            videos: data.videos,
            category: data.category,
            discuss: data.discuss
          },
          okText: data.rough == 1 ? "发表" : "保存",

          onSuccess: () => {
            this.$parent.$emit("on-updated");
          }
        });
      });
    },
    // 删除
    doDel() {
      this.$Modal.confirm({
        title: "确定要删除该帖子？",
        content: this.row.title,
        onOk: () => {
          this.$Ajax("remove-topic", {
            topicId: this.topicId
          }).then(rs => {
            if (rs.status == 1) {
              this.$Message.success({
                content: rs.msg,
                onClose: () => {
                  this.$parent.$emit("on-updated");
                  //window.location.reload()
                }
              });
            }
          });
        }
      });
    },
    // 举报
    doReport() {
      if (this.isLogin) {
        this.$RModal.report({
          name: this.row.title,
          selection: {
            topicId: this.topicId
          }
        });
      } else {
        this.$mypopup({
          onSuccess: () => {
            this.$RModal.report({
              name: this.row.title,
              selection: {
                topicId: this.topicId
              }
            });
          }
        })
      }
    },
    // 分享
    doShare() {
      this.$RModal.share({
        selection: {
          topicId: this.topicId,
          title: this.row.title,
          desc: this.row.desc,
          attachments: this.row.attachments
        }
      });
    }
  },
  mounted() {
    this.$Message.config({
      top: 100
    });
  },
  beforeUpdate() { },
};
</script>